import { curveStep, curveLinear } from 'd3-shape';

import { formatRainfall } from '../../utils/formatters';
import { xAxis } from '../../utils/panelgraph/components/axis-x';
import { lineSeries } from '../../utils/panelgraph/components/series';
import { yAxis } from '../../utils/panelgraph/components/axis-y';
import { panel } from '../../utils/panelgraph/components/panel';
import { plotLine } from '../../utils/panelgraph/components/plot-line';
import { graph } from '../../utils/panelgraph/components/graph';
import { getMonthNames } from '../../utils/date-utils';
import { TOOLTIP_MODE } from '../../utils/panelgraph/constants';

export const yearlyRainfallGraphFactory = (data, containerBoundingRect, opts) => {

	const { rainUnit, colors, activeSeries } = opts;

	const monthNames = getMonthNames();

	const transformedData = data.average.map(avg => {

		const mmdd = avg.date;
		const monthNum = parseInt(mmdd.slice(0, 2), 10);
		const day = parseInt(mmdd.slice(3), 10);

		const pt = {
			day: avg.day,
			date: day + ' ' + monthNames[monthNum - 1]
		};

		if (activeSeries.indexOf('average') !== -1) {
			pt.average = avg.rainfall;
		}

		return pt;

	});

	data.years.forEach(yearData => {

		if (activeSeries.indexOf(`${yearData.year}`) !== -1) {
			const seriesKey = `${yearData.year}`;

			yearData.values.forEach(value => {
				const index = value.day - 1;
				transformedData[index][seriesKey] = value.rainfall;
			});
		}

	});

	let tickValues = transformedData
		.filter(d => d.date.slice(0, 2) === '1 ')
		.map(d => d.day);

	// small window size needs less ticks.
	if (containerBoundingRect.width < 640) {
		tickValues = tickValues.filter((t, i) => i % 3 === 0);
	}

	const xAxisFormatter = day => {
		const record = transformedData.filter(d => d.day === day)[0];
		return record.date.slice(2, 5);
	};

	const tooltipFormatter = pt => pt.date;

	const dateAxis = xAxis()
		.data(pt => pt.day)
		.range([transformedData[0].day, transformedData[transformedData.length - 1].day])
		.tooltipFormatter(tooltipFormatter)
		.tickValues(tickValues)
		.formatter(xAxisFormatter);

	const series = [];

	data.years.forEach((yearData, index) => {
		const year = yearData.year;

		if (activeSeries.indexOf(`${year}`) !== -1) {
			series.push(
				lineSeries(`yearly_rainfall_${year}`)
					.color(colors[index])
					.curve(curveStep)
					.data(pt => pt[year] === null ? null : pt[year])
					.label(`${year}`)
					.tooltipFormatter(pt => formatRainfall(pt[year], rainUnit) + ' ' + rainUnit)
			);
		}

	});

	if (activeSeries.indexOf('average') !== -1) {

		const avgSeries = lineSeries('yearly_rainfall_average')
			.curve(curveLinear)
			.data(pt => pt.average === null ? null : pt.average)
			.label('Mean')
			.tooltipFormatter(pt => formatRainfall(pt.average, rainUnit) + ' ' + rainUnit);

		series.push(avgSeries);

	}

	const rainAxis = yAxis()
		.formatter(v => Math.round(v))
		.constraints({
			fixedMinValue: 0,
			stepOptions: [100, 200, 250, 400, 500]
		});

	const rainPanel = panel()
		.series(series)
		.axisDual(rainAxis);

	const plotLines = tickValues.map(value => plotLine().x(value - 0.5));

	// We'll disabled to legend and create our own interactive one.
	return graph('yearly_rainfall')
		.margin([15, 45, 20, 45])
		.height(w => Math.max(300, 0.66 * w))
		.data(transformedData)
		.xAxis(dateAxis)
		.panels([rainPanel])
		.plotLines(plotLines)
		.legendEnabled(false)
		.tooltipMode(TOOLTIP_MODE.COMBINED_REVERSE);

};



// WEBPACK FOOTER //
// ./components/yearly-rain-graph/graph-factory.js